import API from "../lib/api";


export const getAllPrinterApi = async (restaurantId) => {
    try {
        const { data } = await API.get( 
            `/restaurant/${restaurantId}/printer-settings`
        );

        return data;
    } catch (error) {
        return (
            error.response?.data || {
                status: "failure",
                message: "Something went wrong.",
            }
        );
    }
}

export const getPrinterByIdApi = async (id) => {
    try {
        const response = await API.get(`/restaurant/printer-settings/${id}`);
        return response.data;
    } catch (error) {        return (
            error.response?.data || {
                status: "failure",
                message: "Something went wrong.",
            }
        );
    }
}


export const addPrinterApi = async (data) => {
    try {
        const response = await API.post("/restaurant/printer-settings", data);
        return response.data;
    }
    catch (error) {
        return (
            error.response?.data || {
                status: "failure",
                message: "Something went wrong.",
            }
        );
    }
}


export const updatePrinterApi = async (id, data) => {  
  try {
    const response = await API.put(`/restaurant/printer-settings/${id}`, data);
    return response.data;
  } catch (error) {
    console.error("Error updating printer settings:", error);
    return {
      status: "failure",
      message: error.response?.data.message || "Error updating printer settings.",
    };
  }
};


export const deletePrinterApi  = async (id) => {
    try {
        
        const response = await API.delete(`/restaurant/printer-settings/${id}`);

        return response.data;
    } catch (error) {
        return error.response.data;
    }
}


export const getAllPrinterSlip = async () => {
  try {
    const response = await API.get("/admin/printer-slips");
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};
